import {
  GOAL_PLANNING_INTEREST_IDS,
  type GoalPlanningInterestId,
} from '@/components/goalPlanning/goalPlanningConstants';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/language-hooks';
import { cn } from '@/lib/utils';
import { useState } from 'react';

interface InterestsStepProps {
  initialInterests?: GoalPlanningInterestId[];
  onSubmit: (interests: GoalPlanningInterestId[]) => void;
  isSubmitting?: boolean;
}

export const InterestsStep = ({
  initialInterests = [],
  onSubmit,
  isSubmitting = false,
}: InterestsStepProps) => {
  const { t } = useLanguage();
  const [selected, setSelected] = useState<GoalPlanningInterestId[]>(initialInterests);

  const toggle = (id: GoalPlanningInterestId) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <div className='space-y-4'>
      <p className='text-muted-foreground text-sm'>{t('goalPlanning.interests.description')}</p>

      <div className='flex flex-wrap gap-2'>
        {GOAL_PLANNING_INTEREST_IDS.map((id) => {
          const active = selected.includes(id);
          return (
            <button
              key={id}
              type='button'
              onClick={() => toggle(id)}
              className={cn(
                'rounded-full border px-3 py-1.5 text-sm transition-colors',
                active
                  ? 'border-primary bg-primary/10 text-foreground'
                  : 'border-border text-muted-foreground hover:border-primary/50'
              )}
            >
              {t(`goalPlanning.interests.options.${id}`)}
            </button>
          );
        })}
      </div>

      <Button
        type='button'
        className='w-full'
        disabled={isSubmitting}
        onClick={() => onSubmit(selected)}
      >
        {isSubmitting ? t('common.loading') : t('goalPlanning.interests.finish')}
      </Button>
    </div>
  );
};
